import React from 'react';
import {Alert} from 'componentLibrary';

const LoginGovInfo = () => {
  return (
    <React.Fragment>
      <Alert info header="Login.gov">
        <br />
        <Alert.Header>What is Login.gov?</Alert.Header>
        <p>
          Login.gov is a service that offers secure and private online access to
          government programs, such as federal benefits, services and applications. With a
          Login.gov account, you can sign into multiple government websites with the same
          email address and password.
        </p>
        <br />
        <Alert.Header>How do I get started with Login.gov?</Alert.Header>
        <p>
          If you do not already have a Login.gov account, visit the site by clicking the
          Sign in with Login.gov button above. At the login page, select "Create an
          account" and follow the prompts to create your account with your email address
          and at least one method of authentication (such as a mobile phone number or a
          link to authenticator app).
        </p>
      </Alert>
    </React.Fragment>
  );
};

export default LoginGovInfo;
